import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Button, Input, Spin } from 'antd';
import { Modal, Icon, DatePicker, LocaleProvider, List } from 'antd-mobile';
import { MuiPickersUtilsProvider, DatePicker as MuiDatePicker } from '@material-ui/pickers';
import InputAdornment from '@material-ui/core/InputAdornment';
import Event from '@material-ui/icons/Event';
import DateFnsUtils from '@date-io/date-fns';
import enUS from 'antd-mobile/lib/locale-provider/en_US';
import moment from 'moment';
import LocalStorage from '../../utils/localStorage';
import Toast from 'antd-mobile/lib/toast';
import * as SignalR from '@aspnet/signalr';
import { Markup } from 'interweave';
import IdleTimer from 'react-idle-timer';

const { Content } = Layout;
const { TextArea } = Input;
const confirmAlert = Modal.alert;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'VersionStore',
    'templateStore',
    'CmsLanguageStore',
    'popupStore',
    'loginStore',
    'wakeUpCallStore',
    'webSettingStore',
    'TransactionStore'
)
@observer
class WakeUpCallPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        };
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        };

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.wakeUpCallStore.initWakeUpCallConfirm();

        this.props.CmsLanguageStore.getActives().then(() => {
            this.props.templateStore.getActive().then(() => {
                this.props.webSettingStore.getData().then(() => {
                    const { activeTemplate } = this.props.templateStore;
                    const { data: webSettting } = this.props.webSettingStore;

                    if (webSettting) {
                        this.props.popupStore.getByModuleName('WAKE_UP_CALL').then(resp => {
                            if (resp) {
                                if (resp.title) {
                                    confirmAlert(
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                            color: activeTemplate.templateSetting.label.color,
                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                        }}>
                                            <span>{resp.title}</span>
                                        </div>,
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                            color: activeTemplate.templateSetting.text.color,
                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
                                        }}>
                                            <Markup content={resp.description} />
                                        </div>,
                                        [
                                            {
                                                text: <span style={{
                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                    color: activeTemplate.templateSetting.label.color,
                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                }}>OK</span>
                                            }
                                        ]);
                                }
                            }
                        });

                    }
                });
            });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    componentDidUpdate() {
        this.calendarStyle();
    }

    componentWillUnmount() {
        this.props.wakeUpCallStore.resetData();
    }

    calendarStyle = () => {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        if (webSettting) {
            const input = document.getElementsByClassName('MuiInputBase-input');

            for (let i = 0; i < input.length; i++) {
                input[i].style.fontFamily = `${activeTemplate.templateSetting.text.fontFamily}`;
                input[i].style.fontSize = `${activeTemplate.templateSetting.text.fontSize}px`;
                input[i].style.lineHeight = `${activeTemplate.templateSetting.text.fontSize + 2}px`;
                input[i].style.color = activeTemplate.templateSetting.text.color;
            }
        }
    }

    dateDeliverOnChange = (obj) => {
        this.props.wakeUpCallStore.setDateDeliver(obj.date);
        this.props.wakeUpCallStore.setDateDeliverDate(obj.date);
    }

    timeDeliverOnChange = (obj) => {
        const selectedDate = moment(obj.date).format('HH:mm');
        this.props.wakeUpCallStore.setTimeDeliver(selectedDate);
        this.props.wakeUpCallStore.setTimeDeliverDate(obj.date);
    }

    timeDeliverSecondOnChange = (obj) => {
        const selectedDate = moment(obj.date).format('HH:mm');
        this.props.wakeUpCallStore.setTimeDeliverSecond(selectedDate);
        this.props.wakeUpCallStore.setTimeDeliverDateSecond(obj.date);
    }

    // ON CLICK

    back = () => {
        this.props.history.push('/');
    }

    confirm = () => {
        this.props.TransactionStore.settransactionLoading(true);
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        };

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            } else {
                const { activeTemplate } = this.props.templateStore;

                const {
                    data: webSettting
                } = this.props.webSettingStore;

                const {
                    remark,
                    dateDeliver,
                    timeDeliver,
                    timeDeliverSecond,
                    menu
                } = this.props.wakeUpCallStore;

                let summaryRemark = '';

                let orders = [];
                let order = {
                    'taskId': menu.taskId,
                    'menuId': menu.taskId,
                    'scheduleTime': '',
                    'menuQuantity': 1,
                    'remark': '',
                    'amount': 0
                };

                orders.push(order);

                if (remark && remark !== '') {
                    summaryRemark = `${webSettting.remarkText}: ${remark}. `;
                }

                const scheduleTime = `${dateDeliver} ${timeDeliver}`;
                summaryRemark = `${summaryRemark}Preferred Date Time (1st): ${scheduleTime}.`;

                if (timeDeliverSecond !== '') {
                    const scheduleTimeSecond = `${dateDeliver} ${timeDeliverSecond}`;
                    summaryRemark = `${summaryRemark} Preferred Date Time (2nd): ${scheduleTimeSecond}. `;
                }

                const request = {
                    'tenantId': LocalStorage.Get('companyId'),
                    'roomNumber': LocalStorage.Get('roomNo'),
                    'guestId': LocalStorage.Get('customerId'),
                    'summaryRemark': summaryRemark,
                    'data': orders
                };

                this.props.TransactionStore.create(request).then((resp) => {
                    if (resp.success) {
                        confirmAlert(
                            <div
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                <span>{webSettting.orderPopupTitleText}</span>
                            </div>,
                            <div
                                style={{
                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                    color: activeTemplate.templateSetting.text.color,
                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
                                    textAlign: 'center'
                                }}
                            >
                                <span>{webSettting.orderPopupSuccessText}</span>
                            </div>,
                            [
                                {
                                    text:
                                        <span
                                            style={{
                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                color: activeTemplate.templateSetting.label.color,
                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                            }}
                                        >
                                            {webSettting.backToHomeText}
                                        </span>,
                                    onPress: () => {
                                        this.props.history.push('/');
                                    }
                                },
                                {
                                    text:
                                        <span
                                            style={{
                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                color: activeTemplate.templateSetting.label.color,
                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                            }}
                                        >
                                            {webSettting.goToOrderText}
                                        </span>,
                                    onPress: () => {
                                        this.props.history.push('/order');
                                    }
                                }
                            ]);
                    } else {
                        confirmAlert(
                            <div
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                <span>Error</span>
                            </div>,
                            <div
                                style={{
                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                    color: activeTemplate.templateSetting.text.color,
                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
                                    textAlign: 'center'
                                }}
                            >
                                <span>{webSettting.orderPopupFailedText}</span>
                            </div>,
                            [
                                {
                                    text:
                                        <span
                                            style={{
                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                color: activeTemplate.templateSetting.label.color,
                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                            }}
                                        >
                                            OK
                                        </span>
                                }
                            ]);
                    }
                });
            }
        });
    }

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            remark,
            dateDeliverDate,
            timeDeliver,
            timeDeliverDate,
            timeDeliverSecond,
            timeDeliverDateSecond,
            minDate,
            minDateSecond,
            menu
        } = this.props.wakeUpCallStore;

        const { transactionLoading } = this.props.TransactionStore;

        if (webSettting) {
            if (transactionLoading) {
                Toast.loading(<span style={{
                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                    fontSize: activeTemplate.templateSetting.text.fontSize,
                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                }}>{webSettting.processingOrderLoadingText}</span>, 100, null, true);
            } else {
                Toast.hide();
            }
        }

        let confirmEnabled = timeDeliver !== '';

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            <Layout className='stm-layout'>
                                <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                                <>
                                    {
                                        webSettting
                                            ?
                                            <Content>
                                                {/* Header */}
                                                <>
                                                    <Row>
                                                        <Col
                                                            span={24}
                                                            className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                                            style={{
                                                                fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                                background: activeTemplate.templateSetting.header.backgroundColor,
                                                                color: activeTemplate.templateSetting.header.color,
                                                                fontSize: activeTemplate.templateSetting.header.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                            }}
                                                        >
                                                            <Row>
                                                                <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={this.back}>
                                                                    <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                                                </Col>
                                                                <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                                                    {menu ? menu.taskName : ''}
                                                                </Col>
                                                                <Col span={4} />
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </>

                                                {/* Banner */}
                                                <>
                                                    {
                                                        menu
                                                            ?
                                                            <>
                                                                {
                                                                    menu.bannerUrl === null || menu.bannerUrl === ''
                                                                        ?
                                                                        <Row className='stm-margin-top-50' />
                                                                        :
                                                                        <>
                                                                            <Row className='stm-height-160 stm-margin-top-50 stm-background-size-100-percent'>
                                                                                <Col span={24} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-160'>
                                                                                    <img src={menu.bannerUrl} alt='Icon' />
                                                                                </Col>
                                                                            </Row>
                                                                        </>
                                                                }
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </>

                                                {/* Body */}
                                                <>
                                                    {
                                                        menu
                                                            ?
                                                            <>
                                                                {
                                                                    menu.isAvailable
                                                                        ?
                                                                        <>
                                                                            <Row className='stm-margin-top-10 stm-background-white'>
                                                                                <Col span={1} />
                                                                                <Col span={22}>

                                                                                    {/* Task Description */}
                                                                                    <>
                                                                                        {
                                                                                            menu.taskDesc !== ''
                                                                                                ?
                                                                                                <Row className='stm-tab-description-container'>
                                                                                                    <Col span={24} className='stm-tab-description'>
                                                                                                        <Row>
                                                                                                            <Col span={3} className='stm-tab-description-image'>
                                                                                                                <img src={require('../../assets/image/Icon/HelpInfo.svg')} alt='HelpInfo' className='stm-item-desc-image' />
                                                                                                            </Col>
                                                                                                            <Col span={21} className='stm-tab-description-text'>
                                                                                                                <Markup content={menu.taskDesc} />
                                                                                                            </Col>
                                                                                                        </Row>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                                :
                                                                                                null
                                                                                        }
                                                                                    </>

                                                                                    <Row className='stm-margin-top-10 stm-background-white stm-padding-bottom-100'>

                                                                                        {/* Preferred Date */}
                                                                                        <>
                                                                                            <Col
                                                                                                span={24}
                                                                                                className='stm-margin-top-16'
                                                                                                style={{
                                                                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                                                    color: activeTemplate.templateSetting.label.color,
                                                                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                                                }}
                                                                                            >
                                                                                                {webSettting.preferredDateText}
                                                                                            </Col>
                                                                                            <Col
                                                                                                span={24}
                                                                                                className='stm-margin-top-8'
                                                                                            >
                                                                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                                                    <MuiDatePicker
                                                                                                        value={dateDeliverDate}
                                                                                                        onChange={date => this.dateDeliverOnChange({ date })}
                                                                                                        format='dd MMMM yyyy'
                                                                                                        InputProps={{
                                                                                                            endAdornment: (
                                                                                                                <InputAdornment position="end">
                                                                                                                    <Event />
                                                                                                                </InputAdornment>
                                                                                                            ),
                                                                                                        }}
                                                                                                        minDate={new Date()}
                                                                                                        maxDate={new Date(Date.now() + 12096e5)}
                                                                                                        okText={webSettting.okText}
                                                                                                        dismissText={webSettting.cancelText}
                                                                                                        className='stm-calendar' />
                                                                                                </MuiPickersUtilsProvider>
                                                                                            </Col>
                                                                                        </>

                                                                                        {/* Preferred Time (1st) */}
                                                                                        <>
                                                                                            <Col
                                                                                                span={24}
                                                                                                className='stm-margin-top-16'
                                                                                                style={{
                                                                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                                                    color: activeTemplate.templateSetting.label.color,
                                                                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                                                }}
                                                                                            >
                                                                                                {webSettting.preferredTimeText} (1st)
                                                                                            </Col>
                                                                                            <Col span={24} className='stm-margin-top-8'>
                                                                                                <Row>
                                                                                                    <LocaleProvider locale={enUS}>
                                                                                                        <DatePicker
                                                                                                            mode='time'
                                                                                                            value={timeDeliverDate}
                                                                                                            locale={enUS}
                                                                                                            onOk={date => this.timeDeliverOnChange({ date })}
                                                                                                            onDismiss={() => this.setState({ timePickerVisible: false })}
                                                                                                            use12Hours={false}
                                                                                                            okText={webSettting.okText}
                                                                                                            dismissText={webSettting.cancelText}
                                                                                                            minDate={minDate}
                                                                                                        >
                                                                                                            <List.Item className='stm-list-time' onClick={() => this.setState({ timePickerVisible: true })}>
                                                                                                                {timeDeliver === '' ?
                                                                                                                    <Col
                                                                                                                        span={24}
                                                                                                                        className='stm-list-category'
                                                                                                                        style={{
                                                                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                                            lineHeight: `${webSettting.textontSize + 2}px`,
                                                                                                                            color: activeTemplate.templateSetting.text.color,
                                                                                                                            border: `1px solid ${activeTemplate.templateSetting.buttonItem.borderColor}`,
                                                                                                                            minHeight: 44
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <Row className='stm-width-100-percent'>
                                                                                                                            <Col span={20}>{webSettting.selectTimeText}</Col>
                                                                                                                            <Col span={4} className='stm-text-align-right stm-padding-right-10'>
                                                                                                                                <img src={require('../../assets/image/Clock.svg')} alt='Clock' className='stm-width-16 stm-height-16' />
                                                                                                                            </Col>
                                                                                                                        </Row>
                                                                                                                    </Col>
                                                                                                                    :
                                                                                                                    <Col
                                                                                                                        span={24}
                                                                                                                        className='stm-list-category'
                                                                                                                        style={{
                                                                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                                            lineHeight: `${webSettting.textontSize + 2}px`,
                                                                                                                            color: activeTemplate.templateSetting.text.color,
                                                                                                                            border: `1px solid ${activeTemplate.templateSetting.buttonItem.borderColor}`,
                                                                                                                            minHeight: 44
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <Row className='stm-width-100-percent'>
                                                                                                                            <Col span={20}>{timeDeliver}</Col>
                                                                                                                            <Col span={4} className='stm-text-align-right stm-padding-right-10'>
                                                                                                                                <img src={require('../../assets/image/Clock.svg')} alt='Clock' className='stm-width-16 stm-height-16' />
                                                                                                                            </Col>
                                                                                                                        </Row>
                                                                                                                    </Col>
                                                                                                                }
                                                                                                            </List.Item>
                                                                                                        </DatePicker>
                                                                                                    </LocaleProvider>
                                                                                                </Row>
                                                                                            </Col>
                                                                                        </>

                                                                                        {/* Preferred Time (2nd) */}
                                                                                        <>
                                                                                            <Col
                                                                                                span={24}
                                                                                                className='stm-margin-top-16'
                                                                                                style={{
                                                                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                                                    color: activeTemplate.templateSetting.label.color,
                                                                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                                                }}
                                                                                            >
                                                                                                {webSettting.preferredTimeText} (2nd)
                                                                                            </Col>
                                                                                            <Col span={24} className='stm-margin-top-8'>
                                                                                                <Row>
                                                                                                    <LocaleProvider locale={enUS}>
                                                                                                        <DatePicker
                                                                                                            mode='time'
                                                                                                            value={timeDeliverDateSecond}
                                                                                                            locale={enUS}
                                                                                                            onOk={date => this.timeDeliverSecondOnChange({ date })}
                                                                                                            onDismiss={() => this.setState({ timePickerSecondVisible: false })}
                                                                                                            use12Hours={false}
                                                                                                            okText={webSettting.okText}
                                                                                                            dismissText={webSettting.cancelText}
                                                                                                            disabled={timeDeliver === ''}
                                                                                                            minDate={minDateSecond}
                                                                                                        >
                                                                                                            <List.Item className='stm-list-time' onClick={() => this.setState({ timePickerSecondVisible: true })}>
                                                                                                                {timeDeliverSecond === '' ?
                                                                                                                    <Col
                                                                                                                        span={24}
                                                                                                                        className='stm-list-category'
                                                                                                                        style={{
                                                                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                                            lineHeight: `${webSettting.textontSize + 2}px`,
                                                                                                                            color: activeTemplate.templateSetting.text.color,
                                                                                                                            border: `1px solid ${activeTemplate.templateSetting.buttonItem.borderColor}`,
                                                                                                                            background: timeDeliver === '' ? '#F5F5F5' : '#FFFFFF',
                                                                                                                            minHeight: 44
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <Row className='stm-width-100-percent'>
                                                                                                                            <Col span={20}>{webSettting.selectTimeText}</Col>
                                                                                                                            <Col span={4} className='stm-text-align-right stm-padding-right-10'>
                                                                                                                                <img src={require('../../assets/image/Clock.svg')} alt='Clock' className='stm-width-16 stm-height-16' />
                                                                                                                            </Col>
                                                                                                                        </Row>
                                                                                                                    </Col>
                                                                                                                    :
                                                                                                                    <Col
                                                                                                                        span={24}
                                                                                                                        className='stm-list-category'
                                                                                                                        style={{
                                                                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                                            lineHeight: `${webSettting.textontSize + 2}px`,
                                                                                                                            color: activeTemplate.templateSetting.text.color,
                                                                                                                            border: `1px solid ${activeTemplate.templateSetting.buttonItem.borderColor}`,
                                                                                                                            minHeight: 44
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <Row className='stm-width-100-percent'>
                                                                                                                            <Col span={20}>{timeDeliverSecond}</Col>
                                                                                                                            <Col span={4} className='stm-text-align-right stm-padding-right-10'>
                                                                                                                                <img src={require('../../assets/image/Clock.svg')} alt='Clock' className='stm-width-16 stm-height-16' />
                                                                                                                            </Col>
                                                                                                                        </Row>
                                                                                                                    </Col>
                                                                                                                }
                                                                                                            </List.Item>
                                                                                                        </DatePicker>
                                                                                                    </LocaleProvider>
                                                                                                </Row>
                                                                                            </Col>
                                                                                        </>

                                                                                        {/* Remark */}
                                                                                        <>
                                                                                            <Col
                                                                                                span={24}
                                                                                                className='stm-margin-top-16'
                                                                                                style={{
                                                                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                                                    color: activeTemplate.templateSetting.label.color,
                                                                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                                                }}
                                                                                            >
                                                                                                {webSettting.remarkText}
                                                                                            </Col>
                                                                                            <Col span={24} className='stm-margin-top-8'>
                                                                                                <TextArea
                                                                                                    className=''
                                                                                                    rows={3}
                                                                                                    value={remark}
                                                                                                    onChange={(e) => this.props.wakeUpCallStore.setRemark(e.target.value)}
                                                                                                    style={{
                                                                                                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                        color: activeTemplate.templateSetting.text.color,
                                                                                                        fontSize: activeTemplate.templateSetting.text.fontSize
                                                                                                    }}
                                                                                                />
                                                                                            </Col>
                                                                                        </>

                                                                                    </Row>
                                                                                </Col>
                                                                                <Col span={1} />
                                                                            </Row>
                                                                        </>
                                                                        :
                                                                        null
                                                                }
                                                            </>
                                                            :
                                                            <>
                                                                <Row>
                                                                    <Col span={24} className='stm-margin-top-150 stm-text-align-center'>
                                                                        <Spin
                                                                            spinning={true}
                                                                            tip={webSettting.loadingDataText}
                                                                            style={{
                                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                color: activeTemplate.templateSetting.text.color,
                                                                                fontSize: activeTemplate.templateSetting.text.fontSize
                                                                            }}>
                                                                        </Spin>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                    }
                                                </>

                                                {/* Footer */}
                                                <>
                                                    {
                                                        menu
                                                            ?
                                                            <>
                                                                <Row>
                                                                    <Col
                                                                        span={24}
                                                                        className='stm-position-fixed stm-bottom-0 stm-padding-bottom-15 stm-background-white stm-padding-top-15 stm-max-width-500'
                                                                    >
                                                                        <Row>
                                                                            <Col span={1} />
                                                                            <Col span={22} >
                                                                                <Button
                                                                                    className={confirmEnabled ? 'stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2' : 'stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2 stm-opacity-60'}
                                                                                    onClick={confirmEnabled ? this.confirm : null}
                                                                                    style={{
                                                                                        background: activeTemplate.templateSetting.buttonFooter.backgroundColor,
                                                                                        fontFamily: activeTemplate.templateSetting.buttonFooter.fontFamily,
                                                                                        fontSize: activeTemplate.templateSetting.buttonFooter.fontSize,
                                                                                        lineHeight: `${activeTemplate.templateSetting.buttonFooter.fontSize + 2}px`,
                                                                                        color: activeTemplate.templateSetting.buttonFooter.color
                                                                                    }}
                                                                                >
                                                                                    {webSettting.confirmText}
                                                                                </Button>
                                                                            </Col>
                                                                            <Col span={1} />
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </>
                                            </Content>
                                            :
                                            null
                                    }
                                </>
                            </Layout>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default WakeUpCallPage;